<script>
import Dropdown from './Dropdown.vue'
import request from '@/utils/request'
import { mapGetters } from 'vuex'
export default {
    /*
    |--------------------------------------------------------------------------
    | Component > extends
    |--------------------------------------------------------------------------
    */
    extends: Dropdown, // End of Component > extends

    computed: {
        ...mapGetters(['dataSegmentId', 'loading']),
        dataSegmentId() {
            if (this.$store.getters.dataSegmentId) {
                // console.log('getters IN LIST', this.$store.getters.dataSegmentId)

                return this.$store.getters.dataSegmentId
            } else {
                // console.log('env in list')

                return process.env.VUE_APP_SSA_ACCOUNT
            }
            // if (!this.$store.getters.dataSegmentId || this.$store.getters.dataSegmentId === null) {
            //     console.log('env in list')
            //     return process.env.VUE_APP_SSA_ACCOUNT
            // } else {
            //     console.log('getters IN LIST', this.$store.getters.dataSegmentId)
            //     return this.$store.getters.dataSegmentId
            // }
        },
    },
    /*
    |--------------------------------------------------------------------------
    | Component > props
    |--------------------------------------------------------------------------
    */
    props: {
        textField: {
            type: String,
            default: 'title',
        },
        valueField: {
            type: String,
            default: '_id',
        },
    }, // End of Component > props

    /*
    |--------------------------------------------------------------------------
    | Component > data
    |--------------------------------------------------------------------------
    */
    data() {
        return {
            options: [],
            accountType: '',
        }
    }, // End of Component > mounted

    /*
    |--------------------------------------------------------------------------
    | Component > watch
    |--------------------------------------------------------------------------
    */
    watch: {
        dataSegmentId(value) {
            if (value) {
                // this.getRecords()
                this.getRegRecords()
            }
        },

        /***
         * Setting values to show in Preview Form
         */
        model(value) {
            if (value) {
                let selectedItem = this.options.find(
                    (item) => item._id === value
                )

                if (this.field.key == 'basicInfo.genderId') {
                    // console.log('FieldName ' + this.field.key)
                    // console.log('basicInfo.genderId ' + selectedItem.title)

                    this.$store.commit('updateField', {
                        key: 'basicInfo.gender',
                        value: selectedItem.title,
                    })
                }
                if (this.field.key === 'accountInfo.nomineeNationalityId1') {
                    this.$store.commit('updateField', {
                        key: 'accountInfo.nomineeNationality1',
                        value: selectedItem.title,
                    })
                }

                if (this.field.key == 'accountInfo.nomineeStateId1') {
                    this.$store.commit('updateField', {
                        key: 'accountInfo.nomineeState1',
                        value: selectedItem.title,
                    })
                }

                if (this.field.key == 'accountInfo.purposeOfActionId') {
                    this.$store.commit('updateField', {
                        key: 'accountInfo.purposeOfAction',
                        value: selectedItem.title,
                    })
                }

                if (this.field.key == 'occupationInfo.industryId') {
                    this.$store.commit('updateField', {
                        key: 'occupationInfo.industry',
                        value: selectedItem.title,
                    })
                }
            }
        },
    }, // End of Component > methods

    /*
    |--------------------------------------------------------------------------
    | Component > mounted
    |--------------------------------------------------------------------------
    */
    async mounted() {
        await this.getRegRecords()

        this.setCountries()
        this.setDividend()
    }, // End of Component > data

    /*
    |--------------------------------------------------------------------------
    | Component > methods
    |--------------------------------------------------------------------------
    */
    methods: {
        /**
         * get the dropdown values when required
         *
         * @return {void}
         */
        async getRecords() {
            try {
                // fetch the list of associated configurations

                let { data } = await request({
                    url: `/configurations/${this.field.association}`,
                    params: {
                        dataSegmentId: this.dataSegmentId,
                        status: 'active',
                        perPage: 1000,
                        ref: 'dropdown',
                    },
                })

                // update the local list of options
                this.options = data.data
                // console.log("list options", this.options)
                if (this.field.type === 'isd-code') {
                    this.options = this.options.filter((item) => {
                        item.isdCodeTitle = `${item.title} (${item.isdCode})`
                        return item
                    })
                }
            } catch (error) {
                // console.log(error)
            }
        }, // End of getRecords() method

        async getRegRecords() {
            try {
                if (this.field.type === 'isd-code') {
                    let { data } = await request({
                        url: '/configurations/getJsList',
                        params: {
                            listName: 'jsCountries',
                            status: 'active',
                            perPage: 1000,
                            ref: 'dropdown',
                        },
                    })
                    this.options = data.data
                } else {
                    let { data } = await request({
                        url: '/configurations/getComponentData',
                        params: {
                            dataSegmentId: this.dataSegmentId,
                            listName: this.field.association,
                            status: 'active',
                            perPage: 1000,
                            ref: 'dropdown',
                        },
                    })
                    this.options = data.data
                }
                // console.log("data ", data)
                // update the local list of options
                

                if (this.field.type === 'isd-code') {
                    this.options = this.options.filter((item) => {
                        item.isdCodeTitle = `${item.title} (${item.isdCode})`
                        return item
                    })
                }
            } catch (error) {}
        },

        setDividend() {
            let divId = ''
            let div = ''
            if (this.field.key === 'accountInfo.stockDividendId') {
                if (this.options) {
                    this.options.forEach((element) => {
                        // console.log('Element.title', element.title)
                        const str = 'Re-Invest'
                        const str2 = str.charAt(0).toUpperCase() + str.slice(1)
                        if (element.title == str2) {
                            divId = element._id
                            div = element.title
                        }
                    })
                }
                if (
                    this.field.key === 'accountInfo.stockDividendId' &&
                    !this.$store.getters.getField('accountInfo.stockDividendId')
                ) {
                    this.$store.commit('updateField', {
                        key: 'accountInfo.stockDividend',
                        value: div,
                    })
                    this.$store.commit('updateField', {
                        key: 'accountInfo.stockDividendId',
                        value: divId,
                    })
                }
            }
        },
        setCountries() {
            let natId = ''
            let nat = ''
            let val = ''
            if (
                this.field.key === 'basicInfo.countryOfResidenceId' ||
                this.field.key === 'basicInfo.nationalityId'
            ) {
                if (this.options) {
                    this.options.forEach((element) => {
                        // console.log('Element.title', element.title)
                        const str = 'Pakistan'
                        const str2 = str.charAt(0).toUpperCase() + str.slice(1)
                        if (element.title == str2) {
                            natId = element._id
                            nat = element.title
                            val = element.value
                        }
                    })
                }
                if (
                    this.field.key === 'basicInfo.countryOfResidenceId' &&
                    !this.$store.getters.getField(
                        'basicInfo.countryOfResidenceId'
                    )
                ) {
                    this.$store.commit('updateField', {
                        key: 'basicInfo.countryOfResidence',
                        value: nat,
                    })
                    this.$store.commit('updateField', {
                        key: 'basicInfo.countryOfResidenceId',
                        value: natId,
                    })
                    if (this.dataSegmentId == process.env.VUE_APP_RC_ACCOUNT) {
                        this.$store.commit('updateField', {
                            key: 'regAccInfo.country',
                            value: val,
                        })
                    }
                } else if (
                    this.field.key === 'basicInfo.nationalityId' &&
                    !this.$store.getters.getField('basicInfo.nationalityId')
                ) {
                    this.$store.commit('updateField', {
                        key: 'basicInfo.nationality',
                        value: nat,
                    })
                    this.$store.commit('updateField', {
                        key: 'basicInfo.nationalityId',
                        value: natId,
                    })
                    if (this.dataSegmentId == process.env.VUE_APP_RC_ACCOUNT) {
                        this.$store.commit('updateField', {
                            key: 'regAccInfo.nationality',
                            value: val,
                        })
                    }
                }
            }
        },
    }, // End of Component > watch
}
</script>
